





















































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppCheckRound from '@/components/AppCheckRound.vue'
import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import { Order, OrderDelivery } from '@/interfaces'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppCheckRound,
    AppTwoColsCard
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop() readonly returnMethod!: string
  @Prop() readonly order!: Order
  @Prop() readonly orderDelivery!: OrderDelivery

  get sellerFullAddress () {
    const seller = this.orderDelivery.seller
    if (!seller) {
      return
    }

    return this.getFullAddressText({ zipcode: seller.shop.zipcode, address: seller.shop.address, extraAddress: seller.shop.extraAddress })
  }
}
